import firebase from 'firebase/app'
import {useDocumentData} from 'react-firebase-hooks/firestore'
import useAuth from '../hooks/useAuth.js'

const useDocumentUser = () => {
  const {user} = useAuth()

  const ref = user && firebase.firestore().collection('users').doc(user.uid)

  return useDocumentData(ref)
}

export default useDocumentUser
